export type Step = {
  n: string;
  title: string;
  body: string;
  chips?: string[];
  chipStyle?: 'bracket' | 'plain';
};

export const steps: Step[] = [
  { n: '01', title: 'Choose your task', body: 'You need to respond to a new lead.' },
  { n: '02', title: 'Open the relevant prompt', body: 'Find the appropriate framework inside THE REALTOR AI PLAYBOOK™.' },
  {
    n: '03',
    title: 'Customize the brackets',
    body: 'Add your:',
    chips: ['[CITY]', '[PROPERTY TYPE]', '[PRICE RANGE]', '[CLIENT DETAILS]', '[GOAL]'],
    chipStyle: 'bracket',
  },
  {
    n: '04',
    title: 'Paste into your AI',
    body: 'Works with:',
    chips: ['ChatGPT', 'Claude', 'Gemini', 'Other AI Assistants'],
    chipStyle: 'plain',
  },
  {
    n: '05',
    title: 'Review & refine',
    body: 'Receive a structured starting point you can review, customize and adapt to your professional needs.',
  },
];

export const workflowNodes = [
  { label: 'Prompt', sub: 'Your instruction' },
  { label: 'AI', sub: 'ChatGPT · Claude · Gemini' },
  { label: 'Output', sub: 'Structured professional starting point' },
  { label: 'You', sub: 'Review · Customize · Verify · Use' },
];

export const positioningRows = [
  { label: 'Leads', outcome: 'Generate opportunities' },
  { label: 'Listings', outcome: 'Market properties' },
  { label: 'Conversion', outcome: 'Move conversations forward' },
  { label: 'Negotiation', outcome: 'Prepare for objections' },
  { label: 'Follow-Up', outcome: 'Stay organized' },
  { label: 'Authority', outcome: 'Build visibility' },
];
